<mat-dialog-content style="padding: 0 !important;">
    <div *ngIf="eventType == 'dailyScheduleEvent'" style="display: flex; height: 100%">
        <div style="flex-direction: row; display: flex; flex: 1;">
            <div class="contentLeft">
                <div mat-dialog-title>
                    <span translate>{{event.title}}</span>
                </div>
                <div>
                    {{event.start | date:'shortTime' }} - {{event.end | date:'shortTime'}} &nbsp; <span
                        *ngIf="event.meta.event.Room != null" translate>Room</span>
                    {{event.meta.event.Room}}
                    &nbsp; {{event.meta.event.TeacherName}}
                </div>
                <div>
                    <span style="color:#757575" translate>Attendance</span> {{attendanceStatus()}}
                </div>
                <div style="padding-top: 10px">
                    <table style="width:100%; border-collapse: collapse;">
                        <thead>
                        <tr style="vertical-align: bottom">
                            <th><span translate>Assignments Due</span> {{eventDetails.Date | date:'MM/dd/yy'}}</th>
                            <th style="width: 14%;" translate>Category</th>
                            <th style="width: 12%; text-align: right; padding-right: 20px" translate>Possible Points</th>
                            <th translate>Assigned</th>
                        </tr>
                        </thead>
                        <tbody *ngFor="let assignment of assignments; let i = index">
                        <tr style="border-top: 1px solid #757575;border-right-style: none;border-bottom-style: none;border-left-style: none;">
                            <td>{{assignment.Assignment}}</td>
                            <td style="white-space: nowrap;">{{assignment.Category}}</td>
                            <td style="text-align: right; padding-right: 20px">{{assignment.Possible}}</td>
                            <td style="padding-right: 20px">{{assignedDate(assignment.AssignedDate)}}</td>
                        </tr>
                        <tr *ngIf="!!assignment.Description" style="height: 30px; color: #757575;">
                            <td colspan="4" style="padding-left:20px;" translate>Details</td>
                        </tr>
                        <tr *ngIf="!!assignment.Description" style="height: 30px;">
                            <td colspan="4" style="padding-left:20px;"><p [innerHTML]="assignment.Description"></p></td>
                        </tr>
                        <tr *ngIf="assignment.Attachment > 0" style="height: 30px; color: #757575;">
                            <td colspan="4" style="padding-left:20px;" translate>Attachments</td>
                        </tr>
                        <tr *ngFor="let attachment of assignment.Attachments" style="height: 30px;">
                            <td colspan="4" style="padding-left:20px;"><p><u (click)="attachmentClick(attachment)"
                                                                             style="color: blue;">{{attachment.FileName}}</u>
                                <span *ngIf="isV10"> ({{attachment.OriginalFileName}}
                                    ) {{attachmentDescription(attachment)}} </span></p>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="sideNav">
                <a (click)="route('Assignments')" translate>Assignments</a>
                <a (click)="route('Attendance')" translate>Attendance</a>
                <a (click)="route('Grades')" translate>Grades</a>
                <br>
                <a (click)="route('Email Teacher')" translate>Email Teacher</a>
                <br>
                <a *ngIf="isV10" (click)="route('Course Description')" translate>Course Description</a>
                <a *ngIf="isV10" (click)="route('Class Information')" translate>Class Information</a>
                <a *ngIf="isV10" (click)="route('Teacher Profile')" translate>Teacher Profile</a>
            </div>
        </div>
    </div>
    <div *ngIf="eventType == 'districtEvent'" class="flex-content">
        <div style="color:#757575" translate>
            Details
        </div>
        <div translate>
            Location {{eventDetails.Location}}
        </div>
        <div *ngIf="eventDetails.EventDetails != ''">
            <p>{{eventDetails.EventDetails}}</p>
        </div>
        <div *ngIf="eventDetails.EventDetails == ''" translate>
            <p>No description for this event</p>
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions>
    <div class="flex-footer-right">
        <tyl-button image="Cancel.png" label="Close" (clickEvent)="closeClick()" translate></tyl-button>
    </div>
</mat-dialog-actions>
